<template>
  <div
    class="c-section"
    :class="{
      'c-section--transparent': isTransparent,
      'c-section--large-padding': largePadding,
      'c-section--overlay': overlay,
      'c-section--small-padding': smallPadding,
      'c-section--no-horizontal-padding': noHorizontalPadding,
      'c-section--no-vertical-padding': noVerticalPadding,
      'c-section--no-top-padding': noTopPadding,
      'c-section--no-bottom-padding': noBottomPadding,
      'c-section--poi': poiHeader,
      'c-section--borderless': borderless,
      'c-section--primary': primary
    }"
  >
    <slot />
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OSection',
  props: {
    isTransparent: {
      type: Boolean,
      default: false
    },
    largePadding: {
      type: Boolean,
      default: false
    },
    smallPadding: {
      type: Boolean,
      default: false
    },
    noHorizontalPadding: {
      type: Boolean,
      default: false
    },
    noVerticalPadding: {
      type: Boolean,
      default: false
    },
    noTopPadding: {
      type: Boolean,
      default: false
    },
    noBottomPadding: {
      type: Boolean,
      default: false
    },
    poiHeader: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-section {
  background: #fff;
  padding: 1.6rem;
  position: relative;

  p {
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  p:not(:last-child) {
    margin-bottom: 1.6rem;
  }

  & + & {
    border-top: 0.1rem solid $gray-100;
  }

  strong {
    font-weight: 600;
    letter-spacing: -0.033rem;
  }

  a {
    color: $primary-color;
    color: var(--primary-color);
    text-decoration: none;
  }

  ol {
    list-style-type: decimal;
    padding-left: 2.4rem;

    & > li {
      margin-bottom: 1.6rem;
      padding-left: 1.6rem;
    }
  }

  img {
    display: block;
    margin: 2.4rem 0;
    max-width: 100%;
  }

  .c-card-example {
    display: block;
    height: auto;
    margin: 3.2rem auto 3.2rem;
    max-width: 100%;
  }
}

.c-section--primary {
  background: rgba($primary-color, 0.1);
  background: var(--primary-color-light);
}

.c-section--borderless {
  border-color: transparent !important;
}

.c-section--transparent {
  background: none;
}

.c-section--large-padding {
  padding: 2.4rem;
}

.c-section--small-padding {
  padding: 1.2rem 1.6rem;
}

.c-section--no-horizontal-padding {
  padding-left: 0;
  padding-right: 0;
}

.c-section--no-vertical-padding {
  padding-top: 0;
  padding-bottom: 0;
}

.c-section--no-top-padding {
  padding-top: 0;
}

.c-section--no-bottom-padding {
  padding-bottom: 0;
}

.c-section--poi {
  padding-top: 4.8rem;
}

.c-section--overlay {
  padding-left: 2.4rem;
  padding-right: 2.4rem;
}
</style>
